module.exports = __webpack_public_path__ + "assets/53d25d0e7a27bbe49b193ddfc962bdce.svg";